export default __webpack_public_path__ + "static/media/william-the-buffalo.ea42b4da.jpg";